/** @format */

import React, { useRef } from "react";
import { Box, Typography, styled } from "@mui/material";

import themeData from "../../../data/themeData";
import { useLocation } from "react-router-dom";

const MuiBox = styled(Box)(({ theme, bgcolor }) => ({
  overflow: "hidden",
  background: bgcolor,
  flexShrink: 0,
  width: "100%",
  boxSizing: "border-box",
  padding: "8px",
  textAlign: "center",
}));

const SplashNewsHorizontal = ({ horizontalData = [], selectedTheme }) => {
  const marqueeRef = useRef(null);
  let text = horizontalData.map((d) => `${d.text}`);
  const location = useLocation();

  if (
    location.pathname.startsWith("/sch") ||
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/forgot-password") ||
    location.pathname.startsWith("/student_course_content")
  ) {
    return null;
  }

  const backgroundColor =
    selectedTheme === 1 ? "#33415c" : themeData.darkPalette.primary.main;

  const handlePause = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop();
    }
  };

  const handlePlay = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start();
    }
  };

  return (
    <MuiBox bgcolor={backgroundColor}>
      <marquee
        direction="left"
        ref={marqueeRef}
        onMouseEnter={handlePause}
        onMouseLeave={handlePlay}>
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "14px",
            color: "#fff",
            cursor: "pointer",
          }}>
          {text.join(" || ")}
        </Typography>
      </marquee>
    </MuiBox>
  );
};

export default SplashNewsHorizontal;
